import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "image.icon",
  "use": "image.icon-usage",
  "viewBox": "-1006 -15852.761 296 225.521",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1006 -15852.761 296 225.521\" id=\"image.icon\"><defs><style>#image.icon .cls-2{fill:#ffa254}</style></defs><g id=\"image.icon_Group_1134\" data-name=\"Group 1134\" transform=\"translate(-542 273.24)\" opacity=\".5\"><path id=\"image.icon_Subtraction_91\" data-name=\"Subtraction 91\" class=\"cls-2\" d=\"M225.522,296v0H0V0H225.522V296ZM10.57,10.57V285.426H214.951V10.57Z\" transform=\"rotate(90 7979 -8147)\" /><path id=\"image.icon_Path_208\" data-name=\"Path 208\" class=\"cls-2\" d=\"M11.35,109.17h0L70.235,0l42.921,78.894,40.93-39.685,69.019,90.367H0Z\" transform=\"translate(-437.634 -16075.994)\" /><ellipse id=\"image.icon_Ellipse_12\" data-name=\"Ellipse 12\" class=\"cls-2\" cx=\"22.07\" cy=\"23.724\" rx=\"22.07\" ry=\"23.724\" transform=\"translate(-244.598 -16075.42)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/image.icon.svg
// module id = 4rHz
// module chunks = 13